import { createFileRoute, Link } from "@tanstack/react-router";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { PageHeader } from "@/components/PageStates";

export const Route = createFileRoute("/forgot")({
  component: Forgot,
});

function Forgot() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  return (
    <div className="app-viewport bg-bg">
      <PageHeader title="找回密码" onBack={() => history.back()} />
      <div className="px-6 pt-6">
        {!sent ? (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              setSent(true);
            }}
            className="space-y-4"
          >
            <p className="text-[var(--fs-sm)]" style={{ color: "var(--muted)" }}>
              输入邮箱,我们会发送重置链接。
            </p>
            <div className="space-y-1.5">
              <Label htmlFor="email">邮箱</Label>
              <Input
                id="email"
                type="email"
                inputMode="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <Button type="submit" className="h-12 w-full">
              发送重置邮件
            </Button>
          </form>
        ) : (
          <div className="rounded-[var(--r-lg)] border bg-surface p-6 text-center">
            <div
              className="mx-auto mb-3 grid h-12 w-12 place-items-center rounded-full"
              style={{ background: "var(--accent-soft)", color: "var(--accent)" }}
            >
              ✓
            </div>
            <h2 className="text-[var(--fs-lg)] font-semibold">邮件已发送</h2>
            <p
              className="mt-2 text-[var(--fs-sm)]"
              style={{ color: "var(--muted)" }}
            >
              请查收 {email || "邮箱"} 并点击链接重置密码。
            </p>
            <Link
              to="/"
              className="mt-6 inline-block text-[var(--fs-sm)]"
              style={{ color: "var(--accent)" }}
            >
              返回登录
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
